import { useCallback, useEffect, useMemo, useState } from 'react';

import {
  type PartnerDto,
  type PartnerTaskDto,
} from '@/common/types/query/tasks';

const useVisitTask = (
  key: 'lastVisitedPartnerTaskId' | 'lastVisitedSocialTaskId',
  taskList?: PartnerDto,
): {
  isVisited: boolean | null;
  data: PartnerTaskDto | null;
  saveVisit: () => void;
} => {
  const [isVisited, setIsVisited] = useState<boolean | null>(null);
  const lastTask = useMemo(
    (): PartnerTaskDto | null =>
      taskList ? taskList.partnerTask.slice(-1)[0] : null,
    [taskList],
  );
  const saveVisit = useCallback(() => {
    if (lastTask) {
      localStorage.setItem(key, lastTask.id);
    }
  }, [lastTask]);

  useEffect(() => {
    const lastVisitedTaskId = localStorage.getItem(key);

    if (lastVisitedTaskId && lastTask) {
      setIsVisited(lastTask.id === lastVisitedTaskId);
    }
  }, [lastTask]);

  return { isVisited, data: lastTask, saveVisit };
};

export { useVisitTask };
